import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CampaignContentService } from './campaign-content.service';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private campaignContentService = inject(CampaignContentService);
  private isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  public toAuthentication(returnUrl, strapiUid = null) {
    if (this.isBrowser) {
      sessionStorage.setItem('vmo2_zeus_returnUrl', returnUrl);
    }

    if (strapiUid) {
      this.toUrl(`/status/~authentication?strapiUid=${strapiUid}`);
    } else {
      this.toUrl(`/status/~authentication`);
    }    
  }

  public toReturnUrl() {
    const returnUrl = sessionStorage.getItem('vmo2_zeus_returnUrl');
    sessionStorage.removeItem('vmo2_zeus_returnUrl');
    if (returnUrl) {
      this.toUrl(returnUrl);
    } else {
      this.toAppStart();
    }
  }
  
  public toAppStart() {
    this.toUrl('/status');
  }

  public toUrl(url: string) {
    if (url) {
      if (url?.startsWith('http')) {
        if (this.isBrowser) {
          if (url?.endsWith('pdf')) {
            window.open(url, '_blank');
          } else {
            window.location.href = url;
          }
        }
      } else {
        let routeData: any = this.campaignContentService.appendCampaignCodeToQueryString(url);
        routeData = this.getRouteData(routeData);

        if (url?.includes('/~')) {
          if (this.isBrowser) {
            history.pushState({}, '', window.location.pathname);
          }
          this.router.navigate([routeData.route], {
            relativeTo: this.route,
            skipLocationChange: true,
            queryParams: routeData.params,
          });
        } else {
          this.router.navigate([routeData.route], { relativeTo: this.route, queryParams: routeData.params });
        }
      }
    }
  }

  private getRouteData(url: string) {
    let route = url;
    let params = null;
    if (url.includes('?')) {
      const urlParts = url.split('?');
      route = urlParts[0];
      const queryParamsString = urlParts[1];
      params = this.parseQueryParams(queryParamsString);
    }
    return { route, params };
  }

  private parseQueryParams(queryString: string): { [key: string]: any } {
    return queryString
      .split('&')
      .map((param) => param.split('='))
      .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {});
  }

  public toApiError(status, api) {
    const pageURL = this.isBrowser ? window?.location?.href : '';

    let addQueryParams = `/status/api-error?status=${status}&api=${encodeURIComponent(
      api
    )}&referrer=${encodeURIComponent(pageURL)}`;

    if (pageURL.includes('?embeddedWebApp=true')) {
      addQueryParams = `${addQueryParams}&embeddedWebApp=true`;
    }

    if (this.isBrowser) {
      sessionStorage.setItem('h-a-e', true.toString());
    }
    this.router.navigateByUrl(addQueryParams);
  }

  public isEmbeddedWebApp() {
    let isEmbeddedWebApp = false;
    if (this.isBrowser) {
      if (!sessionStorage.getItem('embeddedWebApp')) {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('embeddedWebApp')) {
          isEmbeddedWebApp = urlParams.get('embeddedWebApp') === 'true';
        }
        sessionStorage.setItem('embeddedWebApp', isEmbeddedWebApp.toString());
      } else {
        isEmbeddedWebApp = sessionStorage.getItem('embeddedWebApp') === 'true';
      }
    }
    return isEmbeddedWebApp;
  }
}
